import { render, staticRenderFns } from "./ViewPEAApprovalRolesAndUsers.vue?vue&type=template&id=7214a03c&scoped=true"
import script from "./ViewPEAApprovalRolesAndUsers.vue?vue&type=script&lang=js"
export * from "./ViewPEAApprovalRolesAndUsers.vue?vue&type=script&lang=js"
import style0 from "./ViewPEAApprovalRolesAndUsers.vue?vue&type=style&index=0&id=7214a03c&prod&scoped=true&lang=css"
import style1 from "./ViewPEAApprovalRolesAndUsers.vue?vue&type=style&index=1&id=7214a03c&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7214a03c",
  null
  
)

export default component.exports